import { render, staticRenderFns } from "./EditTintCategory.vue?vue&type=template&id=9f4936d4&"
import script from "./EditTintCategory.vue?vue&type=script&lang=js&"
export * from "./EditTintCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports